import axios from "axios";

export const isApiUnreachable = (error: unknown): boolean =>
  axios.isAxiosError(error)
  && !error.response
  && error.code !== "ERR_CANCELED";
